exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".property-in-row {  \r\n  margin-top: 15px; \r\n}\r\n\r\n.header-seccion-form {\r\n\tbackground-color: #d2d0d0;\t\r\n}\r\n\r\n.letra-en-botones {\r\n\tfont-size: 1.3em;\r\n}\r\n\r\n.letra-botones {\r\n\tfont-size: 14px;\r\n}\r\n\r\n.botones-docs {\r\n\tborder: 1px solid black;\r\n    width: 50px;\r\n    height: 50px;\r\n    color: #ff8a65;\r\n}\r\n\r\n.content-text-tabs-inside {\r\n\ttext-align: justify;\r\n    padding: 0px 25px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Selector Formularios UNR/ng_usuarios_no_registrados/ng_usuarios_no_registrados/src/app/components/selector/selector.component.css
// module id = ../../../../../src/app/components/selector/selector.component.css
// module chunks = main